import styled from 'styled-components'
import colors from '../../lib/colors'

export const CardError = styled.div`
  color: ${colors.red};
  font-weight: bold;
  display: flex;
  justify-content: flex-end;
  margin-top: -4px;
  margin-right: 25px;
  height: 15px;
`
